const LOADER_SELECTOR = '[data-mda-loader]';

export class Loader {
    constructor(el = null) {
        this.root =
            el ||
            (typeof document !== 'undefined'
                ? document.querySelector(LOADER_SELECTOR)
                : null);

        if (!this.root) {
            return;
        }
    }

    show() {
        if (!this.root) {
            return;
        }

        this.root.classList.add('active', 'flex');
        this.root.classList.remove('hidden');
        this.root.setAttribute('aria-hidden', 'false');
    }

    hide() {
        if (!this.root) {
            return;
        }

        this.root.classList.remove('active', 'flex');
        this.root.classList.add('hidden');
        this.root.setAttribute('aria-hidden', 'true');
    }
}
